import { render, staticRenderFns } from "./ToylandSignup.vue?vue&type=template&id=227494e3"
import script from "./ToylandSignup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToylandSignup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ToylandSignup.vue?vue&type=style&index=0&id=227494e3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports